
export const BREAKPOINTS = {
  smallMobile: 360,  // baseline — supported floor
  mobile: 480,       // larger phones
  tablet: 600,       // small tablets / large phones landscape
  laptop: 960,       // laptops / large tablets
  desktop: 1280,     // standard desktop
  wide: 1600,        // wide desktop
};

export const media = {
  mobile: `@media (min-width: ${BREAKPOINTS.mobile}px)`,
  tablet: `@media (min-width: ${BREAKPOINTS.tablet}px)`,
  laptop: `@media (min-width: ${BREAKPOINTS.laptop}px)`,
  desktop: `@media (min-width: ${BREAKPOINTS.desktop}px)`,
  wide: `@media (min-width: ${BREAKPOINTS.wide}px)`,
};
